import produce from 'immer'

import {
  INSIGHTS_LOAD,
  INSIGHTS_RELOAD,
  INSIGHTS_LOAD_SUCCESS,
  INSIGHTS_RELOAD_SUCCESS,
  INSIGHTS_LOAD_FAILURE
} from './actions'

interface InsightsState {
  loading: boolean
  error: any
  items: any[]
  count: number
}

const initialState: InsightsState = {
  loading: false,
  error: null,
  items: [],
  count: 0
}

export const reducer = (state = initialState, action: any): InsightsState => {
  return produce(state, draft => {
    switch (action.type) {
      case INSIGHTS_LOAD: {
        draft.loading = true
        draft.error = null
        break
      }

      case INSIGHTS_RELOAD: {
        // Silent reload - don't set loading to true
        break
      }

      case INSIGHTS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.items = action.insights
        draft.count = action.insights.length
        break
      }

      case INSIGHTS_RELOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.items = action.insights
        draft.count = action.insights.length
        break
      }

      case INSIGHTS_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        break
      }

      default:
        break
    }
  })
}
